import React from 'react'
import styles from './Introduction.module.scss'

interface Props {
  contents: {
    title: string
    list: {
      icon: string
      text: string[]
    }[]
  }
}

const Introduction: React.FC<Props> = ({ contents }) => {
  const AssignmentCards = contents.list.map((item, index) => {
    const TextBr = item.text.map((text, index) => (
      <React.Fragment key={index}>
        {text}
        {index < item.text.length - 1 && <br />}
      </React.Fragment>
    ))
    return (
      <div key={index} className={styles.assignment_card}>
        <img src={item.icon} alt="" className={styles.icon} />
        <p>{TextBr}</p>
      </div>
    )
  })

  return (
    <div className={styles.introduction_section}>
      <div className={styles.introduction_title}>{contents.title}</div>
      <div className={styles.assignments}>{AssignmentCards}</div>
    </div>
  )
}
export default Introduction
